import config from 'appConfig';
import Auth from '@getgo/auth-client';

const redirectUrl = `${window.location.protocol}//${window.location.host}/authenticate.html`;
export const USER_LOGOUT = 'USER_LOGOUT';

export const authReset = () => ({ type: 'AUTH_RESET' });

export const options = {
  client_id: config.oauth.clientId,
  url: config.oauth.url,
  redirect_url: redirectUrl,
  enableTokenRefresh: true,
  onTokenRefresh: () => {
    localStorage.removeItem('endToEnd');
    sessionStorage.removeItem('endToEnd');
    return Promise.resolve();
  },
  tokenRefreshTimestamp: (token) => token.expires - 30000
};

export const auth = new Auth(options);

export const login = (path) => {
  // Attempt to initialize with a token from storage (if you persist it)
  const storage = window.sessionStorage;
  const token = auth.init(JSON.parse(storage.getItem('endToEnd')));
  if (token) {
    // User is authenticated, redirect to the path
    window.location.href = path;
    return;
  }

  // Initial visit, start login process
  storage.setItem('pkce_path', path);
  const state = auth.randomString(32);
  const codeVerifier = auth.randomString(64);

  storage.setItem('pkce_state', state);
  storage.setItem('pkce_code_verifier', codeVerifier);
  // No path to store here, will be set by authRedirect

  auth.loginWithPKCE({ state, code_verifier: codeVerifier });
};

// Only authRedirect receives path, stores it for use after login
export const authRedirect = (path) => {
  login(path);
  return { type: 'AUTH_REDIRECT' };
};

export const logout = (path) => {
  const { clientId, url } = config.oauth;
  const fullUrl = `${url}/oauth/logout?client_id=${clientId}&redirect_uri=${path}`;

  const authLogout = new Auth({
    client_id: config.oauth.clientId,
    url: config.oauth.url,
    redirect_url: path
  });

  authLogout.logout();

  return {
    type: 'USER_LOGOUT',
    path: fullUrl
  };
};
